module.exports = __webpack_public_path__ + "3801d3c422f4344adf74b8748e3c86f7.png";